import { styled } from 'goober';
import CrossIcon from '../../assets/checkoutWidget/cross-icon.svg';
import HomeIcon from '../../assets/salesApp/home-icon.svg';
import Style from './style.css';
import { Fragment } from 'preact';
import {
  useSalesContext,
  useSalesDispatchContext,
} from '../../storeProviders/salesAppStore';
import { salesEmiHomeRoute } from '../../alias/salesAppRoutes';
import { replaceInitialSalesAppRoute } from '../partial/container/salesAppContainer';
import Skeleton from './Skeleton';
import { useSalesAppTracker } from './tracker';
import { SalesApiErrorCodes } from '../../api/controllers/salesController';

const Container = styled('div')`
  width: 100%;
  background: #ffffff;
  box-shadow: 1px 1px 6px rgba(174, 174, 174, 0.25);
  padding: 8px 16px 8px 16px;
  .iconBorder {
    border-radius: 2px;
    line-height: 0;
    width: 32px;
    height: 32px;
    padding: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .iconButton {
    color: #656565;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .iconButton i {
    font-size: 20px;
  }
  .merchantName {
    font-weight: 500;
    font-size: 16px;
    line-height: 1.5;
    color: #696b6c;
    margin-left: 5px;
  }
  .merchantLogo {
    height: 100%;
    width: 100%;
  }
`;

const MainDiv = styled('div')`
  justify-content: space-between;
  flex-wrap: nowrap;
  margin: 0px auto;
`;

const Icon = styled('div')`
  align-self: center;
  cursor: pointer;
  #homeIcon {
    color: #a0a0a0;
  }
`;

const RightSubContainer = styled('div')`
  padding-left: 10px;
`;

const WarningTimeContain = styled('div')`
  position: absolute;
  left: 0px;
  color: rgb(99, 99, 99);
  top: 48px;
  width: 100%;
  padding: 4px;
  text-align: center;
  background: #fff4ec;
  font-size: 14px;
  border-radius: 0px 0px 4px 4px;
  & span {
    color: rgb(255, 108, 0);
  }
`;

export default function Header() {
  const pageKey = 'sa_click_nav_home';
  const salesStore = useSalesContext();
  const salesDispatch = useSalesDispatchContext();
  const salesAppTracker = useSalesAppTracker(pageKey);
  const { merchantData, currentUrl, prevSalesAppError } = salesStore;
  const { type, merchantName, merchantLogo } = merchantData;

  const isAgentBlocked = () => {
    if (prevSalesAppError) {
      return prevSalesAppError.errorCode === SalesApiErrorCodes.AGENT_BLOCKED;
    }
    return false;
  };
  const renderHeader = () => {
    return !!(merchantName && merchantLogo);
  };
  const handleBack = () => {
    window.location.pathname === currentUrl ||
    isAgentBlocked() ||
    !renderHeader()
      ? salesDispatch({
          type: 'SEND_MESSAGE',
          payload: {
            actionName: 'closeSAApp',
            payload: {},
          },
        })
      : window.history.back();
  };
  const onCloseBtnClick = () => {
    salesDispatch({
      type: 'SEND_MESSAGE',
      payload: {
        actionName: 'closeSAApp',
        payload: {},
      },
    });
  };

  function CrossIconCompo() {
    return (
      <img
        style={{ marginLeft: '15px', cursor: 'pointer' }}
        src={CrossIcon}
        onClick={() => {
          salesAppTracker.trackClick('sa_click_nav_close', undefined);
          onCloseBtnClick();
        }}
      />
    );
  }

  function HomeIconCompo() {
    return (
      <img
        src={HomeIcon}
        id='homeIcon'
        onClick={() => {
          salesAppTracker.trackClick('sa_click_nav_home', undefined);
          replaceInitialSalesAppRoute(salesEmiHomeRoute.path);
        }}
      />
    );
  }

  return (
    <Fragment>
      <Container>
        <MainDiv className={Style.flexRow}>
          <div className={Style.flexRow} style={{ alignItems: 'center' }}>
            <div
              onClick={() => {
                salesAppTracker.trackClick('sa_click_nav_back', undefined);
                handleBack();
              }}
              className='iconButton'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='15'
                height='12'
                viewBox='0 0 15 12'
                fill='none'>
                <path
                  d='M13.4392 5.06409H3.4248L6.48991 1.47151C6.63323 1.30324 6.70219 1.0863 6.6816 0.868415C6.66101 0.650532 6.55258 0.449552 6.38014 0.309689C6.2077 0.169827 5.98539 0.102539 5.76211 0.122627C5.53884 0.142716 5.33288 0.248536 5.18956 0.416808L0.967646 5.36073C0.939241 5.40005 0.913841 5.44136 0.891651 5.48433C0.891651 5.52553 0.891651 5.55025 0.832544 5.59145C0.794272 5.68592 0.774232 5.78649 0.773438 5.88808C0.774232 5.98967 0.794272 6.09024 0.832544 6.18472C0.832544 6.22592 0.832544 6.25064 0.891651 6.29183C0.913841 6.3348 0.939241 6.37611 0.967646 6.41543L5.18956 11.3594C5.26895 11.4524 5.36837 11.5272 5.48074 11.5784C5.59311 11.6297 5.71568 11.6562 5.83973 11.656C6.03702 11.6564 6.22822 11.5893 6.38014 11.4665C6.46564 11.3973 6.53632 11.3123 6.58812 11.2165C6.63993 11.1206 6.67184 11.0157 6.68204 10.9078C6.69223 10.7999 6.68051 10.691 6.64754 10.5875C6.61457 10.484 6.56101 10.3879 6.48991 10.3047L3.4248 6.71207H13.4392C13.6631 6.71207 13.8779 6.62526 14.0362 6.47073C14.1946 6.3162 14.2836 6.10662 14.2836 5.88808C14.2836 5.66955 14.1946 5.45996 14.0362 5.30543C13.8779 5.15091 13.6631 5.06409 13.4392 5.06409Z'
                  fill='#6C6C6C'
                />
              </svg>
            </div>
            {renderHeader() && (
              <div className={Style.flexRow} style={{ alignItems: 'center' }}>
                <div
                  className='iconBorder'
                  style={{
                    border: merchantLogo
                      ? '1px solid #D3D8E5'
                      : '1px solid transparent',
                  }}>
                  {merchantLogo ? (
                    <img src={merchantLogo} className='merchantLogo' />
                  ) : (
                    <Skeleton style={{ height: '100%', width: '100%' }} />
                  )}
                </div>
                <div className='merchantName'>
                  {merchantName ? (
                    merchantName
                  ) : (
                    <Skeleton style={{ height: '24px', width: '100px' }} />
                  )}
                </div>
              </div>
            )}
          </div>

          <RightSubContainer className={Style.flexRow}>
            <Icon>
              {window.location.pathname !== salesEmiHomeRoute.path ? (
                type !== 'EMI_HOME' || isAgentBlocked() || !renderHeader() ? (
                  <CrossIconCompo />
                ) : (
                  <HomeIconCompo />
                )
              ) : (
                <CrossIconCompo />
              )}
            </Icon>
          </RightSubContainer>
        </MainDiv>
      </Container>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./components/salesApp/Header.js